import UserModel from "../models/user.model";

class Globals {
    static user: UserModel;
    // static apiUrl: string = 'http://192.168.1.200:3000/api';
    static apiUrl: string = 'https://bio.brokermarketing.dz/api';
}

export default Globals;